import { EPaymentMethod, EBankAccountType, EVerificationMethod } from '@/config/payment';

import type { TOption } from '@/types/common';

export const PAYMENT_METHODS: TOption<EPaymentMethod>[] = [
  {
    label: 'payment.method.ach',
    value: EPaymentMethod.ACH,
  },
];

export const VERIFICATION_METHODS: TOption<EVerificationMethod, { details: string }>[] = [
  {
    label: 'stationSetup.connectBank.instantVerification',
    details: 'stationSetup.connectBank.instantVerificationDetails',
    value: EVerificationMethod.INSTANT,
  },
  {
    label: 'stationSetup.connectBank.manualVerification',
    details: 'stationSetup.connectBank.manualVerificationDetails',
    value: EVerificationMethod.MANUAL,
  },
];

export const BANK_ACCOUNT_TYPES: TOption<EBankAccountType>[] = [
  {
    label: 'stationSetup.connectBank.checkingAccount',
    value: EBankAccountType.CHECKING,
  },
  {
    label: 'stationSetup.connectBank.savingsAccount',
    value: EBankAccountType.SAVINGS,
  },
];
